import PageSEO from './PageSEO'

export default PageSEO